import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cctv',
  templateUrl: './cctv.component.html',
  styleUrls: ['./cctv.component.scss']
})
export class CCTVComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
